import { StyleSheet } from "aphrodite";

const layoutStyles = StyleSheet.create({
    contentContainer: {
        margin: '36px 48px',
        minHeight: 'calc(100vh - 98px - 72px)'
    }
});

export default layoutStyles;